import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Access } from 'common';
import { Page, Panel, Pagination, Breadcrumbs, Loading } from 'components';
import { Filters } from './components';

class List extends Component {
  state = {
    filter: {
      local: Access.lockedLocal() ? Access.lockedLocal(true) : { value: '', label: 'Todos' },
      start_at: null,
      end_at: null,
      status: { value: '', label: 'Todos' },
    },
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Eventos', to: '/events' }, { name: 'Lista de Eventos', to: '' }],
  };

  componentDidMount() {
    const { filter } = this.state;
    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : 1;
    this.props.getEventsRequest(page, filter);
  }

  componentDidUpdate(oldProps) {
    const { filter } = this.state;
    const { location } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      this.props.getEventsRequest(queryString.parse(location.search).page, filter);
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getEventsRequest } = this.props;

    await this.setState({ filter: { ...filter, [name]: value } });
    getEventsRequest(1, this.state.filter);
  };

  handleCleanFilter = async e => {
    e.preventDefault();
    const { getEventsRequest } = this.props;

    await this.setState({
      filter: {
        local: Access.lockedStore() ? Access.lockedStore(true) : { value: '', label: 'Todos' },
        start_at: null,
        end_at: null,
        status: { value: '', label: 'Todos' },
      },
    });
    getEventsRequest(1, this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { events } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Eventos</Page.Title>

        <Filters filter={filter} onChange={this.handleChangeFilter} onClean={this.handleCleanFilter} />

        <Panel className="panel-list">
          {!events.data.length && events.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {events.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>descrição</th>
                    <th>loja</th>
                    <th>data do evento</th>
                    <th>vagas/inscritos</th>
                    <th>situação</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!events.data.length && (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {events.data.map((event, index) => (
                    <tr key={String(event.id)}>
                      <td>{event.attributes.name}</td>
                      <td>{event.attributes.description}</td>
                      <td>{event.attributes.local && event.attributes.local.name}</td>
                      <td width="200">{event.attributes.date}</td>
                      <td>
                        {event.attributes.vacancy} / {event.attributes.number_confirmeds}{' '}
                      </td>
                      <td className={event.attributes.status.className}>{event.attributes.status.label}</td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-events') && (
                          <Link to={`/events/${event.id}/edit`} className="button-icon">
                            <span className="glyph glyph-pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="7" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={events.page} total={events.totals} {...this.props} />

              {Access.hasPermissions('edit-events') && (
                <Link className="button-add" to="/events/create">
                  Adicionar Evento
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  events: {
    ...state.events,
    data: EventsSelectors.events(state.events.data),
  },

  stores: {
    ...state.events.stores,
    data: EventsSelectors.stores(state.events.stores.data),
  },
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
